import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewChild, ElementRef,afterNextRender, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SwiperOptions } from 'swiper/types';


@Component({
    selector: 'app-partners',
    templateUrl: './partners.component.html',
    styleUrls: ['./partners.component.scss'],

    standalone: true,
		schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PartnersComponent {
  @ViewChild('partnersSwiper') swiper!: ElementRef<any>;

	swiperConfig: SwiperOptions = {
		spaceBetween: 30,
		slidesPerView: 5,
		pagination: true,
		direction: 'horizontal',
		breakpoints: {
			'100': {
				slidesPerView: 2,
			},
			'640': {
				slidesPerView: 2,
			},
			'768': {
				slidesPerView: 4,
			},
			'1200': {
				slidesPerView: 5
			}
		},
		autoplay: {
			delay: 5000,
		},
		updateOnWindowResize: true,
	}

	partners: {
		src: string;
		name: string;
	}[] = [
    {
			src: "https://assets.broadfactor.com/partners/bry.png",
			name: "bry"
		},
    {
      src: "https://assets.broadfactor.com/partners/b2g-contabilidade.png",
      name: "b2g contabilidade  "
    },
		{
			src: "https://assets.broadfactor.com/partners/aws.webp",
			name: "aws"
		},

		{
			src: "https://assets.broadfactor.com/partners/sommaai.png",
			name: "somma"
		},

    {
      src: "https://assets.broadfactor.com/partners/licitante-extremo.png",
      name: "licitante estremo"
    },
    {
      src: "https://assets.broadfactor.com/partners/siga-pregao.png",
      name: "siga pregao"
    }
	]


	constructor(@Inject(PLATFORM_ID) private _platformId: Object) {
		afterNextRender(() => {
			this.handleUpdateSwiperConfig();
		})
	}

	handleUpdateSwiperConfig(): void {
		if (isPlatformBrowser(this._platformId)) {
			this.swiperConfig = {
				...this.swiperConfig,
				direction: 'horizontal',
			};
	};
	Object.assign(this.swiper.nativeElement, this.swiperConfig);
	this.swiper.nativeElement.initialize();
	}
}
